import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';
import ProductCardWishListButton from '../components/WishListButton';
import ProductImage from '../components/ProductImage';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';

type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
};

export const VerticalProductCardImage = ({ topSlot, bottomSlot }: ProductCardImageProps) => {
  const { ranking } = useProductCard();
  return (
    <Box
      borderRadius="8px"
      background="neutral.50"
      overflow="hidden"
      height={{
        base: '172px',
        tablet: '224px',
      }}
      maxHeight={{
        base: '172px',
        tablet: '224px',
      }}
      boxSizing="border-box"
      padding={{
        base: '20px',
        tablet: '40px',
      }}
      position="relative"
      width="100%"
      minWidth={0}
    >
      <Flex position="absolute" zIndex={2} top={0} left={0} width="100%">
        <>{topSlot}</>
        <ProductCardWishListButton />
      </Flex>
      <ProductImage />
      <Condition
        expression={!isNil(ranking)}
        then={
          <Flex
            position="absolute"
            bottom={0}
            left={0}
            pb="3px"
            h={12}
            w={12}
            alignItems="center"
            justifyContent="center"
          >
            <Text color="neutral.200" textStyle="heading.h2">
              {ranking}
            </Text>
          </Flex>
        }
      />
      <Flex position="absolute" bottom={0} zIndex={2} left={0} width="100%">
        <>{bottomSlot}</>
      </Flex>
    </Box>
  );
};
